$(function(){
    $('.first-page__content-play').on('click', function(){
        $(this).addClass('is-active');
        setTimeout(() => {
            $(this).siblings('video')[0].play();
            console.log('test 123');
        }, 100);
    })
})